// extracted by mini-css-extract-plugin
export default {"wrapperBlueBg":"styles_wrapperBlueBg__Hdczs"};